// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
// import StyledWrapper from "@insite/client-framework/Common/StyledWrapper"; // Starter Custom Code
import { ProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import clearProduct from "@insite/client-framework/Store/Components/ProductSelector/Handlers/ClearProduct";
import reset from "@insite/client-framework/Store/Components/ProductSelector/Handlers/Reset";
import searchProducts from "@insite/client-framework/Store/Components/ProductSelector/Handlers/SearchProducts";
import setProduct from "@insite/client-framework/Store/Components/ProductSelector/Handlers/SetProduct";
import setUnitOfMeasure from "@insite/client-framework/Store/Components/ProductSelector/Handlers/SetUnitOfMeasure";
import { getProductSelector } from "@insite/client-framework/Store/Components/ProductSelector/ProductSelectorSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import translate from "@insite/client-framework/Translate";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import ProductUnitOfMeasureSelect from "@insite/content-library/Components/ProductUnitOfMeasureSelect";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
// import DynamicDropdown, { DynamicDropdownPresentationProps, OptionObject } from "@insite/mobius/DynamicDropdown"; // Starter Custom Code
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon, { IconProps } from "@insite/mobius/Icon";
import X from "@insite/mobius/Icons/X";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import { SelectPresentationProps } from "@insite/mobius/Select";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import debounce from "lodash/debounce";
import React, { ChangeEvent, ReactNode, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import InlineFormButton from "@store/Library/Components/Toolkit/InlineFormButton";
// import DynamicDropdown, {
//     DynamicDropdownPresentationProps,
//     OptionObject,
// } from "@store/MobiusOverrides/DynamicDropdown/DynamicDropdown"; // Store Custom Code
// import ProductPartNumbers, { ProductPartNumbersStyles } from "@store/Overrides/Components/ProductPartNumbers"; // Store Custom Code
// import { autocompleteProps } from "@store/Themes/common/props/autocomplete"; // Store Custom Code
import { inlineFormWithLabelProps } from "@store/Themes/common/props/inlineForm";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import getBooleanProperty from "@toolkit/Framework/Common/Utilities/getBooleanProperty";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import constants from "@store/constants";

/* Store Custom Code - Start */
import DynamicDropdown, {
    DynamicDropdownPresentationProps,
    OptionObject,
} from "@store/MobiusOverrides/DynamicDropdown/DynamicDropdown";
import {
    calculateProductsAdditionalCustomerProductNames,
    getProductMultiLocationCatalogResultMap,
} from "@store/Framework/Common/Utilities/multiLocationCatalogUtilities";
import AvailableAtOtherShipToLabel, {
    AvailableAtOtherShipToLabelPresentationProps,
} from "@store/Library/Components/MultiLocationCatalog/AvailableAtOtherShipToLabel";
import NotInYourCatalogBadge, {
    NotInYourCatalogBadgePresentationProps,
} from "@store/Library/Components/NotInYourCatalogBadge";
import ProductPartNumbers, { ProductPartNumbersStyles } from "@store/Overrides/Components/ProductPartNumbers";
import { autocompleteProps } from "@store/Themes/common/props/autocomplete";
import { InlineFormButtonProps } from "@store/Library/Components/Toolkit/InlineFormButton";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";

export interface ProductSelectorPresentationProps extends ExpandStyles<ProductSelectorStyles> {}
/* Store Custom Code - End */

const StyledSpan = getStyledWrapper("span");
/* Starter Custom Code - End */

// Store Custom Code - next line - export, name, extends
export interface ProductSelectorProps extends ProductSelectorPresentationProps {
    onSelectProduct: (productInfo: ProductInfo, product: ProductModel) => void;
    skipInventoryValidation?: boolean;
    denyFixedConfiguration?: boolean;
    selectButtonTitle?: string;
    productIsConfigurableMessage?: ReactNode;
    productIsUnavailableMessage?: ReactNode;
    customErrorMessage?: ReactNode;
    // Store Removed - extendedStyles
    // Starter Custom Code
    showSku?: boolean;
    // Store Custom Code - extra deps for InlineFormButton recalculation (e.g. accordion open)
    additionalButtonUpdateProps?: InlineFormButtonProps["updateProps"];
}

const mapStateToProps = (state: ApplicationState) => {
    const { isSearching, searchResults, selectedProductInfo, errorType } = getProductSelector(state);
    const product = getProductState(state, selectedProductInfo?.productId).value;
    return {
        isSearching,
        searchResults,
        selectedProductInfo,
        product,
        errorType,
        location: getLocation(state),
    };
};

const mapDispatchToProps = {
    searchProducts,
    setProduct,
    clearProduct,
    setUnitOfMeasure,
    reset,
};

type Props = ProductSelectorProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>; // Store Custom Code

export interface ProductSelectorStyles {
    container?: GridContainerProps;
    searchGridItem?: GridItemProps;
    qtyGridItem?: GridItemProps;
    unitOfMeasureGridItem?: GridItemProps;
    buttonGridItem?: GridItemProps;
    unitOfMeasureSelect?: SelectPresentationProps;
    qtyTextField?: TextFieldPresentationProps;
    optionWrapper?: InjectableCss;
    imageWrapper?: InjectableCss;
    productImage?: LazyImageProps;
    infoWrapper?: InjectableCss;
    autocompleteTitleText?: TypographyPresentationProps;
    autocompleteErpText?: TypographyPresentationProps;
    selectButton?: ButtonPresentationProps;
    searchDynamicDropdown?: DynamicDropdownPresentationProps;
    clearIcon?: IconProps;
    // Starter Custom Code
    formWrapper?: InjectableCss;
    formInnerWrapper?: InjectableCss;
    productPartNumbers?: ProductPartNumbersStyles;
    // Store Custom Code
    availableAtOtherShipToLabel?: AvailableAtOtherShipToLabelPresentationProps;
    notInYourCatalogBadge?: NotInYourCatalogBadgePresentationProps;
}

export const productSelectorStyles: ProductSelectorStyles = {
    formWrapper: inlineFormWithLabelProps.wrapper,
    formInnerWrapper: inlineFormWithLabelProps.innerWrapper,
    searchDynamicDropdown: autocompleteProps.searchDynamicDropdown,
    qtyTextField: mergeProps<ProductSelectorStyles["qtyTextField"]>(inlineFormWithLabelProps.field, {
        cssOverrides: {
            formField: css`
                max-width: ${pxToRem(112) /* Store Custom Code */};
            `,
        },
    }),
    unitOfMeasureSelect: inlineFormWithLabelProps.field,
    selectButton: inlineFormWithLabelProps.button,
    optionWrapper: autocompleteProps.optionWithImageWrapper,
    imageWrapper: autocompleteProps.imageWrapper,
    infoWrapper: autocompleteProps.infoWrapper,
    autocompleteTitleText: autocompleteProps.title,
    autocompleteErpText: autocompleteProps.erpNumber,
    productPartNumbers: autocompleteProps.productPartNumbers,
    /* Store Custom Code - Start */
    availableAtOtherShipToLabel: autocompleteProps.availableAtOtherShipToLabel,
    notInYourCatalogBadge: autocompleteProps.notInYourCatalogBadge,
    /* Store Custom Code - End */
};

const ENTER_KEY = 13;

const ProductSelector = ({
    onSelectProduct,
    skipInventoryValidation,
    denyFixedConfiguration,
    selectButtonTitle,
    searchProducts,
    isSearching,
    searchResults,
    setProduct,
    clearProduct,
    setUnitOfMeasure,
    selectedProductInfo,
    product,
    errorType,
    extendedStyles,
    customErrorMessage,
    productIsConfigurableMessage,
    productIsUnavailableMessage,
    location,
    reset,
    // Starter Custom Code
    showSku = false,
    // Store Custom Code
    overridedStyles,
    additionalButtonUpdateProps,
}: Props) => {
    const [qty, setQty] = useState("1");
    const [qtyHasChanged, setQtyHasChanged] = useState(false);
    const [errorMessage, setErrorMessage] = useState<ReactNode>("");
    const [options, setOptions] = useState<OptionObject[]>([]);
    const [searchTerm, setSearchTerm] = useState("");
    const styles = useExpandProps(productSelectorStyles, extendedStyles, overridedStyles); // Store Custom Code
    /* Starter Custom Code - Start */
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    /* Starter Custom Code - End */

    useEffect(() => {
        reset();
    }, [location.pathname]);

    useEffect(() => {
        if (!searchResults) {
            return;
        }

        /* Store Custom Code - Start */
        const multiLocationCatalogResults = getProductMultiLocationCatalogResultMap(searchResults);
        const productsAdditionalCustomerProductNames = calculateProductsAdditionalCustomerProductNames(
            searchResults,
            multiLocationCatalogResults,
        );
        /* Store Custom Code - End */

        const newOptions = searchResults.map(product => {
            /* Store Custom Code - Start */
            const isMultilocationCatalogProduct = !!multiLocationCatalogResults.get(product.id ?? "")
                ?.isMultiLocationCatalogProduct;
            const isProductNotInCatalog = getBooleanProperty(product.properties?.notInCatalog);
            const showNotInYourCatalogBadge = isProductNotInCatalog && !isMultilocationCatalogProduct;
            const additionalCustomerProductNames = productsAdditionalCustomerProductNames.get(product.id ?? "");
            /* Store Custom Code - End */

            return {
                optionText: showSku ? `${product.erpNumber} - ${product.title}` : product.title, // Starter Custom Code
                optionValue: product.id || undefined,
                rowChildren: (
                    <StyledWrapper
                        {...styles.optionWrapper}
                        data-test-selector={`productSelector_search_${product.id}`}
                    >
                        <StyledWrapper {...styles.imageWrapper} aria-hidden={true} /* Starter Custom Code */>
                            {/* Starter Custom Code - Start */}
                            <LazyImage {...styles.productImage} src={product.image} altText={product.title} />
                            {/* Starter Custom Code - End */}
                        </StyledWrapper>
                        <StyledSpan {...styles.infoWrapper} /* Starter Custom Code */>
                            {/* Store Custom Code - Start */}
                            {isMultilocationCatalogProduct && (
                                <AvailableAtOtherShipToLabel {...styles.availableAtOtherShipToLabel} />
                            )}
                            {showNotInYourCatalogBadge && <NotInYourCatalogBadge {...styles.notInYourCatalogBadge} />}
                            {/* Store Custom Code - End */}
                            <Typography
                                {...styles.autocompleteTitleText}
                                data-test-selector="productSelector_ProductTitle"
                            >
                                {product.displayTitle || product.title}
                            </Typography>
                            <Typography {...styles.autocompleteErpText}>
                                {/* Starter Custom Code - Start */}
                                <ProductPartNumbers
                                    productNumber={product.displayErpNumber || product.erpNumber}
                                    customerProductNumber={product.name} // Store Custom Code
                                    manufacturerItem={product.manufacturerItemNumber}
                                    showCustomerName={!!product.isNameCustomerOverride}
                                    extendedStyles={styles.productPartNumbers}
                                    // Store Custom Code
                                    additionalCustomerProductNumberCount={
                                        additionalCustomerProductNames?.additionalCount
                                    }
                                />
                                {/* Starter Custom Code - End */}
                            </Typography>
                        </StyledSpan>
                    </StyledWrapper>
                ),
            };
        });
        setOptions(newOptions);
    }, [searchResults]);

    useEffect(() => {
        setErrorMessage(customErrorMessage);
    }, [customErrorMessage]);

    useEffect(() => {
        if (selectedProductInfo && !qtyHasChanged) {
            setQty(`${selectedProductInfo.qtyOrdered}`);
        }

        /* Starter Custom Code - Start */
        if (selectedProductInfo) {
            setIsLoading(false);
        }
        /* Starter Custom Code - End */
    }, [selectedProductInfo]);

    useEffect(() => {
        switch (errorType) {
            case "productIsConfigurable":
                setErrorMessage(productIsConfigurableMessage || translate("Cannot select configurable products"));
                break;
            case "productIsUnavailable":
                setErrorMessage(productIsUnavailableMessage || translate("Product is unavailable"));
                break;
            default:
                setErrorMessage("");
                break;
        }
    }, [errorType]);

    const onSelectionChangeHandler = (value?: string) => {
        if (searchResults && searchResults.length > 0) {
            setIsLoading(true); // Starter Custom Code
            const variantParentId = searchResults.find(o => o.id === value)?.styleParentId;
            if (variantParentId) {
                setProduct({
                    productId: variantParentId,
                    variantId: value,
                    validateProduct: true,
                    skipInventoryValidation,
                    denyFixedConfiguration,
                });
            } else {
                setProduct({
                    productId: value,
                    validateProduct: true,
                    skipInventoryValidation,
                    denyFixedConfiguration,
                });
            }
        }
    };

    /* Starter Custom Code - Start */
    const debouncedSearchProducts = React.useCallback(
        debounce((query: string) => {
            searchProducts({ query, relevancy: false });
        }, constants.searchDebounceDelay),
        [searchProducts],
    );
    /* Starter Custom Code - End */

    const onInputChanged = (event: ChangeEvent<HTMLInputElement>) => {
        setErrorMessage("");
        setSearchTerm(event.target.value);

        if (selectedProductInfo) {
            clearProduct();
        }

        if ((event as Partial<typeof event>).preventDefault /* Store Custom Code */) {
            debouncedSearchProducts(event.target.value);
        }
    };

    /* Starter Custom Code - next line - async */
    const selectProduct = async () => {
        if (!selectedProductInfo || errorMessage || !product) {
            return;
        }

        const newProductInfo = { ...selectedProductInfo };
        newProductInfo.qtyOrdered = parseFloat(qty);

        setIsSubmitting(true); // Starter Custom Code
        await onSelectProduct(newProductInfo, product); // Starter Custom Code

        clearProduct();
        setQty("1");
        setQtyHasChanged(false);
        searchProducts({ query: "", relevancy: false });
        setIsSubmitting(false); // Starter Custom Code
    };

    const uomChangeHandler = (unitOfMeasure: string) => {
        if (!selectedProductInfo) {
            return;
        }

        setUnitOfMeasure({ unitOfMeasure });
    };

    const onKeyPress = (event: React.KeyboardEvent) => {
        if (event.charCode === ENTER_KEY) {
            if (selectedProductInfo) {
                selectProduct();
            } else if (searchTerm && (!searchResults || searchResults.length === 0)) {
                setProduct({ searchTerm, skipInventoryValidation, denyFixedConfiguration });
                setIsLoading(true); // Starter Custom Code
            }
        }
    };

    const clearButtonHandler = () => {
        clearProduct();
        setQty("1");
        setQtyHasChanged(false);
        searchProducts({ query: "", relevancy: false });
        /* Store Custom Code - Start */
        setProduct({ searchTerm: "" });
        /* Store Custom Code - End */
    };

    return (
        /* Starter Custom Code - removed Grid */
        <StyledWrapper {...styles.formWrapper} data-test-selector="productSelector">
            <DynamicDropdown
                {...styles.searchDynamicDropdown}
                label={translate("Find product")} // Starter Custom Code
                onSelectionChange={onSelectionChangeHandler}
                onInputChange={onInputChanged}
                onKeyPress={onKeyPress}
                filterOption={() => true}
                selected={selectedProductInfo?.productId} // Store Custom Code
                isLoading={isSearching}
                options={options}
                error={errorMessage}
                data-test-selector="productSelector_search"
                // Starter Custom Code
                showClear={Boolean(selectedProductInfo)}
                clearOnClick={clearButtonHandler}
                placeholder={translate("Enter keyword, item # or part #")} // Starter Custom Code
            />
            {/* Starter Removed - selectedProductInfo/clearIcon/clearButtonHandler */}
            <StyledWrapper {...styles.formInnerWrapper} /* Starter Custom Code */>
                {/* Starter Custom Code - Start */}
                {product && selectedProductInfo && product.unitOfMeasures && product.unitOfMeasures.length > 1 && (
                    <ProductContext.Provider
                        value={{ product, productInfo: selectedProductInfo, onUnitOfMeasureChanged: uomChangeHandler }}
                    >
                        <ProductUnitOfMeasureSelect
                            extendedStyles={styles.unitOfMeasureSelect}
                            data-test-selector="productSelector_uom"
                        />
                    </ProductContext.Provider>
                )}
                {/* Starter Custom Code - End */}
                <TextField
                    type="number"
                    min="0"
                    label={translate("QTY")}
                    value={qty}
                    onChange={e => {
                        setQty(e.currentTarget.value);
                        setQtyHasChanged(true);
                    }}
                    data-test-selector="productSelector_qty"
                    {...styles.qtyTextField} // Starter Custom Code
                />
                {/* Starter Moved - ProductUnitOfMeasureSelect - up */}
                <InlineFormButton /* Starter Custom Code */
                    {...styles.selectButton}
                    onClick={() => selectProduct()}
                    disabled={!selectedProductInfo || !!errorMessage || Number(qty) < 1 || isSubmitting} // Starter Custom Code
                    data-test-selector="productSelector_selectProduct"
                    updateProps={[product, ...(additionalButtonUpdateProps || [])]} // Store Custom Code - extra deps
                    // Starter Custom Code
                    isLoading={isLoading || isSubmitting}
                >
                    {selectButtonTitle || translate("Select Product")}
                </InlineFormButton>
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductSelector);
